import type { ReactNode } from 'react'
import { usePageHeaderActionsRef } from './pageHeaderActions'

/**
 * Paylaşılan sayfa başlığı bloğu (013 tasarım dili — FR-010). Başlık (=sol menü adı) + açıklama +
 * sağ birincil aksiyon. Tüm ekranlar aynı başlık kalıbını bundan alır (Reuse Mandate).
 */
export interface PageHeaderProps {
  title: string
  description?: string
  /** Sağ tarafta gösterilecek birincil aksiyon(lar) — genelde PrimeReact Button. */
  actions?: ReactNode
}

export default function PageHeader({ title, description, actions }: Readonly<PageHeaderProps>) {
  const slotRef = usePageHeaderActionsRef()
  return (
    <div className="ui-page-header">
      {/* Başlık sütunu bir SINIF taşır: `.ui-page-header` bir flex satırıdır ve bu sütun onun öğesidir;
          sınıfsızken `min-width: auto` ile "min-content" kadar yer istiyor, boşluksuz uzun bir başlık
          (ör. 100 karakterlik bir Notlarım liste adı) sayfanın dışına taşıyordu. Bkz. ui.css. */}
      <div className="ui-page-header-titles">
        {/*
          Metin ayrı bir `span`'dedir çünkü `.ui-page-header-title` bir flex KAPTIR: çıplak metin
          düğümü anonim bir flex öğesi olur ve anonim öğeye `min-width: 0` verilemez — h1'e
          verilen de işe yaramaz (ölçüldü: kutu daralıyor, metin yine taşıyordu). Gerçek bir
          eleman olunca kısalabiliyor ve `overflow-wrap` devreye giriyor.
        */}
        <h1 className="ui-page-header-title">
          <span className="ui-page-header-title-text">{title}</span>
        </h1>
        {description && <p className="ui-page-header-sub">{description}</p>}
      </div>
      {/* Aksiyon şeridi: SLOT (alt panellerin portalı) + sayfanın kendi `actions`'ı.
          Şerit, `actions` boş olsa da çizilir — panel butonlarını buraya taşıyan ekranlarda sayfanın
          kendi aksiyonu olmayabilir; koşullu çizilse slot hiç var olmaz ve butonlar yedeğe düşerdi.
          Sıra bilinçli: slot ÖNCE → portal içeriği `actions`'ın SOLUNA düşer (Figma sırası).
          Gerekçenin tamamı: `pageHeaderActions.tsx`. */}
      <div className="ui-page-header-actions">
        <span className="ui-page-header-slot" ref={slotRef} />
        {actions}
      </div>
    </div>
  )
}
